import { useMemo } from "react"
import { useWorkspaceJobsStore } from "@/stores/workspace-jobs-store"
import type { GenerationJobRow } from "@/types/workspace"

/**
 * Какие вкладки сейчас заняты процессом — по задачам, которые уже пришли на страницу
 * (кабель / резервный опрос AppShell), без своих запросов.
 *
 * Подписка — на строку с ключами занятых вкладок, а не на список задач: прогресс и пульс
 * задачи меняют store часто, а вкладка перерисуется, только когда процесс начался или закончился.
 */
export function useBusyTabs(
  compute: (jobs: GenerationJobRow[]) => ReadonlyArray<string | false | null | undefined>,
): ReadonlySet<string> {
  const key = useWorkspaceJobsStore((state) => compute(state.jobs).filter(Boolean).join("|"))
  return useMemo(() => new Set(key ? key.split("|") : []), [key])
}
